/**
 * @param path
 * @return {Array}
 */
function getPathSegments(path) {
    const pathArr = path.split('.');
    const parts = [];

    for (let i = 0; i < pathArr.length; i++) {
        let p = pathArr[i];

        while (p[p.length - 1] === '\\' && pathArr[i + 1] !== undefined) {
            p = p.slice(0, -1) + '.';
            p += pathArr[++i];
        }

        parts.push(p);
    }

    return parts;
}

/**
 *
 * @param {Array|Object} source
 * @param {String} path
 */
export function array_delete(source, path) {
    if (Object(source) !== source || typeof path !== 'string') {
        return;
    }

    const pathArr = getPathSegments(path);

    for (let i = 0; i < pathArr.length; i++) {
        const p = pathArr[i];

        if (i === pathArr.length - 1) {
            delete source[p];
            return;
        }

        source = source[p];

        if (Object(source) !== source) {
            return;
        }
    }
}

/**
 * Get a property from an object following dot-notation
 * @param {Array|Object} source
 * @param {String} path
 * @param {mixed} defaultValue
 * @return {Array|Object}
 */
export function array_get(source, path, defaultValue = undefined) {
    if (Object(source) !== source || typeof path !== 'string') {
        return defaultValue === undefined ? source : defaultValue;
    }

    const pathArr = getPathSegments(path);

    for (let i = 0, len = pathArr.length; i < len; i++) {
        if (!Object.prototype.propertyIsEnumerable.call(source, pathArr[i])) {
            return defaultValue;
        }

        source = source[pathArr[i]];

        if (source === undefined || source === null) {
            // `source` is either `undefined` or `null` so we want to stop the loop, and
            // if this is not the last bit of the path, and
            // if it did't return `undefined`
            // it would return `null` if `source` is `null`
            // but we want `get({foo: null}, 'foo.bar')` to equal `undefined`, or the supplied value, not `null`
            if (i !== pathArr.length - 1) {
                return defaultValue;
            }

            break;
        }
    }

    return source;
}

/**
 *
 * @param {Array} source
 * @param {String} path
 * @return {boolean}
 */
export function array_has(source, path) {
    if (Object(source) !== source || typeof path !== 'string') {
        return false;
    }

    const pathArr = getPathSegments(path);

    for (let i = 0; i < pathArr.length; i++) {
        if (Object(source) === source) {
            if (!(pathArr[i] in source)) {
                return false;
            }

            source = source[pathArr[i]];
        } else {
            return false;
        }
    }

    return true;
}

/**
 * Set a property to an object following dot-notation
 * @param {Array|Object} source
 * @param {String} path
 * @param {mixed} value
 */
export function array_set(source, path, value) {
    if (Object(source) !== source || typeof path !== 'string') {
        return source;
    }

    const root = source;
    const pathArr = getPathSegments(path);

    for (let i = 0, len = pathArr.length; i < len; i++) {
        const p = pathArr[i];

        if (Object(source[p]) !== source[p]) {
            source[p] = {};
        }

        if (i === pathArr.length - 1) {
            source[p] = value;
        }

        source = source[p];
    }

    return root;
}
